/**
 * Cascading (Masonry) grid layout
 *
 * @requires https://github.com/desandro/imagesloaded
 * @requires https://github.com/Vestride/Shuffle
 */

export default (() => {
  const grid = document.querySelectorAll('.masonry-grid')
  let masonry

  if (grid === null) return

  for (let i = 0; i < grid.length; i++) {
    /* eslint-disable no-undef */
    masonry = new Shuffle(grid[i], {
      itemSelector: '.masonry-grid-item',
      sizer: '.masonry-grid-item',
    })

    imagesLoaded(grid[i]).on('progress', () => {
      masonry.layout()
    })
    /* eslint-enable no-undef */

    // Filtering
    const filtersWrap = grid[i].closest('.masonry-filterable')
    if (filtersWrap === null) continue
    const filters = filtersWrap.querySelectorAll(
      '.masonry-filters [data-group]'
    )

    const isGallery = grid[i].classList.contains('gallery')

    for (let n = 0; n < filters.length; n++) {
      filters[n].addEventListener('click', function (e) {
        console.log(
          'filter click handler running, isGallery:',
          isGallery,
          'lgInstance:',
          grid[i]._lgInstance
        )
        const current = filtersWrap.querySelector('.masonry-filters .active')
        const target = this.dataset.group
        if (current !== null) {
          current.classList.remove('active')
        }
        this.classList.add('active')
        masonry.filter(target)

        // Refresh lightgallery with only visible items after shuffle transition
        if (isGallery) {
          setTimeout(() => {
            const lgInst = grid[i]._lgInstance
            if (lgInst) {
              lgInst.settings.selector =
                target === 'all'
                  ? '.gallery-item'
                  : '.masonry-grid-item:not(.shuffle-item--hidden) .gallery-item'
              lgInst.refresh()
            }
          }, 300)
        }

        e.preventDefault()
      })
    }
  }
})()
